function updateReviews() {
    if (document.querySelector(".jdgm--done-setup")) {
        document.querySelectorAll(".product-review-sec  .jdgm-prev-badge__text").forEach(element => {
            if (!element.dataset.modified) { // Prevent duplicate modifications
                const words = element.textContent.split(/\s+/); // Split by spaces
                const rating = words.shift(); // Extract the first element (rating)
                
                element.innerHTML = `<span>${rating}</span> <div class="d-none-">${words.join(' ')}</div>`;
                element.dataset.modified = "true"; // Mark as modified
            }
        });
    }
    setTimeout(updateReviews, 2000); // Check every 2 seconds
}

window.addEventListener("load", () => {
    setTimeout(updateReviews, 500); // Initial delay of 2 seconds before starting
});


document.addEventListener("DOMContentLoaded", function () {
    // Function to update the price based on the selected option
    function updatePrice() {
        let selectedPlan = document.querySelector('input[name="selling_plan"]:checked');
        if (!selectedPlan) return;

        // Get the price elements for the product and compare price
        let productPriceElement = document.querySelector('[data-product-type="price"]');
        let compareAtPriceElement = document.querySelector('[data-product-type="compare_at_price"]');
        let subscriptionWrapper = selectedPlan.closest(".appstle_subscription_radio_wrapper");
        let onetimeWrapper = selectedPlan.closest(".appstle_one_time_details_wrapper");
        let subscriptionAmountWrappers = document.querySelectorAll(".appstle_subscription_amount_wrapper");
        let greenCheckDescription = document.getElementById("green_check_description");
        var readAllLink = document.getElementById("readAllLink");
        let subscriptionUlLists = document.querySelectorAll(".appstleSellingPlanDescription > ul"); // Subscription ULs
        let greenCheckUl = document.querySelector("#green_check_description ul");
        let additionalBlockSets = document.querySelector("#additional-retainers-block");

        let newPrice = '';
        let newCompareAtPrice = '';

        // If selected plan is a subscription
        if (subscriptionWrapper && subscriptionWrapper.querySelector(".appstle_subscription_amount")) {
            newPrice = subscriptionWrapper.querySelector(".appstle_subscription_amount").innerText.trim();
            newCompareAtPrice = subscriptionWrapper.querySelector(".appstle_subscription_compare_amount").innerText.trim();
    
            // Hide green check description
            if (greenCheckDescription) greenCheckDescription.style.display = "none";
            if (additionalBlockSets) additionalBlockSets.style.display = "none";
            if (readAllLink) {
                readAllLink.style.display = "block";
            }

            // Show subscription UL
            subscriptionUlLists.forEach((ul) => {
                ul.style.display = "block";
            });

            // Hide green check UL (even if div is hidden, ensure ul is hidden too)
            if (greenCheckUl) greenCheckUl.style.display = "none";
        }
        // If selected plan is one-time purchase
        if (onetimeWrapper && onetimeWrapper.querySelector(".appstle_subscription_amount")) {
            newPrice = onetimeWrapper.querySelector(".appstle_subscription_amount ").innerText.trim();
            newCompareAtPrice = onetimeWrapper.querySelector(".appstle_subscription_amount_compare_at_price").innerText.trim(); // Corrected here
          
            // Show green check description
            if (greenCheckDescription) greenCheckDescription.style.display = "block";
            if (additionalBlockSets) additionalBlockSets.style.display = "block";
            if (readAllLink) {
                readAllLink.style.display = "none";
            }
            // Show UL inside green check description
            if (greenCheckUl) greenCheckUl.style.display = "block";

            // Hide subscription ULs
            subscriptionUlLists.forEach((ul) => {
                ul.style.display = "none";
            });
        }
        // Update the product price if it's different from the current one
        if (newPrice && productPriceElement && productPriceElement.innerText !== newPrice) {
            productPriceElement.innerText = newPrice;
        }
        // Update the compare price if it's different
        if (newCompareAtPrice && compareAtPriceElement && compareAtPriceElement.innerText !== newCompareAtPrice) {
            compareAtPriceElement.innerText = newCompareAtPrice;
        }
        // Hide compare price for one-time purchase (we want only subscription's compare price shown)
        // if (onetimeWrapper && compareAtPriceElement) {
        //     compareAtPriceElement.style.display = "none";  // Hide compare price for one-time purchase
        // } else if (subscriptionWrapper && compareAtPriceElement) {
        //     compareAtPriceElement.style.display = "block"; // Show compare price for subscription
        // }
    }

    // Run function initially to set the correct price
    updatePrice();
  
    // Add event listener for subscription and one-time purchase option changes
    document.querySelectorAll('input[name="selling_plan"]').forEach((radio) => {
        radio.addEventListener("change", updatePrice);
    });
  
    // Use MutationObserver to detect Appstle Subscription updates
    const observer = new MutationObserver((mutationsList, observer) => {
        let shouldUpdate = false;

        mutationsList.forEach((mutation) => {
            if (mutation.addedNodes.length || mutation.removedNodes.length) {
                shouldUpdate = true;
            }
        });
      
        if (shouldUpdate) {
            updatePrice();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
    const timer = document.getElementById("timer");

    if (!timer) return; // Exit if the countdown section doesn't exist

    const daysEl = document.querySelector("#days p");
    const hoursEl = document.querySelector("#hours p");
    const minutesEl = document.querySelector("#minutes p");
    const secondsEl = document.querySelector("#seconds p");

        function convertToISOAlternative(dateStr) {
          // Replace the 'GMT' part with 'T' and format it to make the string compatible with ISO 8601
          let [datePart, timePart, gmtOffset] = dateStr.split(" ");
          let [hoursOffset, minutesOffset] = gmtOffset.split("+")[1].split(":");
      
          // Create the full ISO format string
          let isoDateStr = `${datePart}T${timePart}${gmtOffset.replace("GMT", "")}`;
      
          // Adjust the timezone in the ISO string
          return isoDateStr.replace('GMT', '');
      }

    function updateTimer() {
        var endTimeStr = timer.dataset.date;
        endTimeStr = convertToISOAlternative(endTimeStr);

        if (!endTimeStr) return; // Exit if no data-date attribute
        
        const endTime = new Date(endTimeStr).getTime(); 
        const now = Date.now();
        let timeLeft = Math.max(0, Math.floor((endTime - now) / 1000));  

        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor((timeLeft % 86400) / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = Math.floor(timeLeft % 60);

        // Update UI
        daysEl.innerHTML = `<span>Days: </span>${days}`;
        hoursEl.innerHTML = `<span>Hours: </span>${String(hours).padStart(2, '0')}`;
        minutesEl.innerHTML = `<span>Mins: </span>${String(minutes).padStart(2, '0')}`;
        secondsEl.innerHTML = `<span>Secs: </span>${String(seconds).padStart(2, '0')}`;

        if (timeLeft > 0) {
            requestAnimationFrame(updateTimer);
        } else {
            // timer.innerHTML = "<h3>Countdown Completed!</h3>";
          daysEl.innerHTML = `<span>Days: </span>00`;
          hoursEl.innerHTML = `<span>Hours: </span>00`;
          minutesEl.innerHTML = `<span>Mins: </span>00`;
          secondsEl.innerHTML = `<span>Secs: </span>00`;
        }
    }

    updateTimer();

var cross = document.querySelector('.countdown-section .cross');
if (cross) {
  cross.addEventListener('click', function() {
    // Find the closest .countdown-section container
    var countdownSection = cross.closest('.countdown-section');
    if (countdownSection) {
      countdownSection.parentElement.classList.add('count-movetop');
      
      // Look for the sibling .shopify-section-header-sticky element (assumed to be unique)
      var sticky = document.querySelector('.shopify-section-header-sticky');
      if (sticky) {
        sticky.classList.add('movetop');
      }
    }
  });
}
});


document.addEventListener("DOMContentLoaded", function () {
    function syncDescriptions() {
        const subscriptionList = document.querySelector(".appstleSellingPlanDescription ul"); // Subscription <ul>
        const oneTimeList = document.querySelector(".appstle_one_time_description_text ul"); // One-time <ul>

        if (subscriptionList && oneTimeList) {
            oneTimeList.innerHTML = subscriptionList.innerHTML; // Copy subscription <ul> to one-time <ul>
        }
    }

    // Observe changes in subscription description
    const subscriptionDescription = document.querySelector(".appstleSellingPlanDescription");
    if (subscriptionDescription) {
        new MutationObserver(syncDescriptions).observe(subscriptionDescription, { childList: true, subtree: true });
    }

    // Observe changes in hidden input field
    const hiddenInput = document.querySelector("input[name='id']");
    if (hiddenInput) {
        new MutationObserver(() => {
            setTimeout(syncDescriptions, 500); // Delay to ensure subscription updates first
        }).observe(hiddenInput, { attributes: true, attributeFilter: ["value"] });
    }

    // **Run on first-time page load**
    setTimeout(syncDescriptions, 500); // Delay to ensure the elements are available
});

document.addEventListener('DOMContentLoaded', function() {
  const fixedEl = document.querySelector('.product-media-left');
  const section = document.querySelector('.product-main-wrappper');
  if (!fixedEl || !section) return;

  // make sure the section is the positioning context:
  section.style.position = section.style.position || 'relative';

  function updatePosition() {
    const vw = window.innerWidth;

    // mobile / narrow: flow normally
    if (vw <= 991) {
      Object.assign(fixedEl.style, {
        position: 'relative',
        top:      '',
        bottom:   '',
        left:     '',
        width:    ''
      });
      return;
    }

    // match parent width so it doesn't resize
    const parent = fixedEl.parentElement;
    fixedEl.style.width = parent.offsetWidth + 'px';

    const scrollY       = window.pageYOffset;
    const viewportH     = window.innerHeight;
    const sectionTop    = section.getBoundingClientRect().top + scrollY;

    var product_image_height = fixedEl.querySelector('.product-media2-inner').offsetHeight;
    
    const sectionBottom = section.offsetHeight - product_image_height; //sectionTop + section.offsetHeight;
    //const elBottom      = scrollY + viewportH;
    const elBottom      = scrollY ;
    const offsetTop   = 80; 
    
    if (scrollY >= sectionBottom) {
      // past the bottom → stick to section bottom
      Object.assign(fixedEl.style, {
        position: 'absolute',
        top:      '',
        bottom:   '0',
        left:     ''
      });
    } else if (scrollY >= sectionTop) {
      // inside section → fix to viewport bottom
      const parentRect = parent.getBoundingClientRect();
      Object.assign(fixedEl.style, {
        position: 'fixed',
        top:      offsetTop + 'px',
      bottom:   '',        // clear bottom
        left:     parentRect.left + 'px'
      });
    } else {
      // before section → sit at section top
      Object.assign(fixedEl.style, {
        position: 'absolute',
        top:      '0',
        bottom:   '',
        left:     '0'
      });
    } 
    
    
  }

  updatePosition();
  window.addEventListener('scroll', updatePosition, { passive: true });
  window.addEventListener('resize', updatePosition);
});

function iconGridSlider() {
    if (window.innerWidth <= 768) {
        $('.icon-grid').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        });
    } else {
        if ($('.icon-grid').hasClass('slick-initialized')) {
            $('.icon-grid').slick('unslick');
        }
    }
}
iconGridSlider();
window.addEventListener('resize', iconGridSlider);

const boxes = document.querySelectorAll('.retainer-box');
const setCountInput = document.getElementById('retainer-set-count');
const variantInput = document.getElementById('variant-id'); // Make sure this exists in your form
const shopifyDropdown = document.querySelector('.pf-variant-select');
const shopifyVariantInput = document.querySelector('input[name="id"]');

boxes.forEach(box => {
  box.addEventListener('click', () => {
    // Clear old selection
    boxes.forEach(b => b.classList.remove('selected'));

    // Highlight selected box
    box.classList.add('selected');

    // Get values
    const set = box.dataset.set;
    const variant = box.dataset.variant;
    const variantText = box.querySelector("p")?.innerText?.replace(/\s+/g, ' ').trim();

    // Update your custom inputs
    setCountInput.value = set;
    if (variantInput) variantInput.value = variant;

    // Update Shopify hidden input for add-to-cart
    if (shopifyVariantInput) shopifyVariantInput.value = variant;

    // Sync dropdown selection (if you want UI to reflect it too)
    if (shopifyDropdown) {
      for (const option of shopifyDropdown.options) {
        const optionText = option.textContent.trim().replace(/\s+/g, ' ');
        if (optionText === variantText) {
          shopifyDropdown.value = option.value;
          shopifyDropdown.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }

    // Update the URL with ?variant=xxxx
    if (variant) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant);
      window.history.replaceState({}, '', url.toString());
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    // Normalize text by removing extra spaces and trimming
    const normalizeText = (text) => text.replace(/\s+/g, ' ').trim();

    // Step 1: Get all variant titles from the additional retainer block
    const retainerBoxes = document.querySelectorAll("#additional-retainers-block .retainer-box p");
    const hiddenVariantTitles = Array.from(retainerBoxes).map(box =>
      normalizeText(box.innerText)
    );

    // Step 2: Get the dropdown
    const variantDropdown = document.querySelector(".pf-variant-select");

    if (variantDropdown) {
      const options = variantDropdown.querySelectorAll("option");

      options.forEach(option => {
        const optionText = normalizeText(option.innerText);
        if (hiddenVariantTitles.includes(optionText)) {
          option.style.display = "none"; // Hides the option
        }
      });

      // Optional: Reselect a visible default
      const visibleOptions = Array.from(options).filter(opt => opt.style.display !== "none");
      if (visibleOptions.length > 0 && variantDropdown.value !== visibleOptions[0].value) {
        variantDropdown.value = visibleOptions[0].value;
        variantDropdown.dispatchEvent(new Event('change'));
      }
    }
  });